import React from "react";

const VARIANTS = {
  error: {
    iconClass: "fas fa-exclamation-triangle",
    color: "#D92D20",
  },
  info: {
    iconClass: "fas fa-info-circle",
    color: "#1982C4",
  },
  success: {
    iconClass: "fas fa-check-circle",
    color: "#8AC926",
  },
};

const containerStyle = {
  backgroundColor: "var(--sl-bg-secondary, #FAFAFA)",
  borderColor: "var(--sl-border-primary, #D5D7DA)",
  borderRadius: 12,
  boxShadow: "0px 1px 2px 0px rgba(10, 13, 18, 0.05)",
  gap: 16,
};

const iconContainerStyle = {
  width: 20,
  height: 20,
  flexShrink: 0,
};

const innerRingStyle = (color) => ({
  inset: "-20%",
  border: `2px solid ${color}`,
  opacity: 0.3,
  borderRadius: 24,
});

const outerRingStyle = (color) => ({
  inset: "-45%",
  border: `2px solid ${color}`,
  opacity: 0.1,
  borderRadius: 24,
});

const iconStyle = (color) => ({
  fontSize: 20,
  color,
  zIndex: 1,
});

const contentStyle = {
  gap: 12,
  minWidth: 0,
};

const textGroupStyle = {
  gap: 4,
};

const ctaStyle = {
  color: "var(--sl-text-brand, #136395)",
  cursor: "pointer",
};

const closeButtonStyle = {
  top: 7,
  right: 7,
  width: 36,
  height: 36,
  borderRadius: 8,
  cursor: "pointer",
  color: "var(--sl-text-tertiary, #535862)",
  fontSize: 16,
};

const SmsStatusAlert = ({ variant, title, description, ctaLabel, ctaHref, ctaTarget = "_blank", onCtaClick, onClose }) => {
  const { iconClass, color } = VARIANTS[variant] || VARIANTS.info;

  return (
    <div className="d-flex flex-row align-items-start position-relative w-100 border rounded p-3 mb-3" style={containerStyle}>
      {onClose && (
        <button
          onClick={onClose}
          className="position-absolute d-flex align-items-center justify-content-center bg-transparent border-0"
          style={closeButtonStyle}
          aria-label="Close"
        >
          <i className="fas fa-times" />
        </button>
      )}
      <div className="position-relative" style={iconContainerStyle}>
        <div className="position-absolute" style={outerRingStyle(color)} />
        <div className="position-absolute" style={innerRingStyle(color)} />
        <i className={iconClass + " position-relative"} style={iconStyle(color)} />
      </div>
      <div className="d-flex flex-column flex-grow-1" style={contentStyle}>
        <div className="d-flex flex-column" style={textGroupStyle}>
          <div className="figma-text sm semibold secondary pr-5">
            {title}
          </div>
          {description && (
            <div className="figma-text sm tertiary">
              {description}
            </div>
          )}
        </div>
        {ctaLabel && onCtaClick && (
          <div>
            <button
              onClick={onCtaClick}
              className="figma-text sm semibold bg-transparent border-0 p-0 text-left"
              style={ctaStyle}
            >
              {ctaLabel}
            </button>
          </div>
        )}
        {ctaLabel && ctaHref && !onCtaClick && (
          <div>
            <a
              href={ctaHref}
              target={ctaTarget}
              rel={ctaTarget === "_blank" ? "noopener noreferrer" : undefined}
              className="figma-text sm semibold"
              style={ctaStyle}
            >
              {ctaLabel}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default SmsStatusAlert;
